import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap-grid.min.css'
import './sass/index.sass'
import Router from './Router';

ReactDOM.render(<Router />, document.getElementById('root'));
